<template>
  <div class="profile scrollable">
    <profile-card :user=user :regions=weatherRegions></profile-card>
  </div>
</template>

<script>
import ProfileCard from '../components/profile/Profile'
import { mapState } from 'vuex'

export default {
  name: 'profile',
  components: {
    ProfileCard
  },
  data: function () {
    return {
    }
  },
  computed: {
    ...mapState({
      user: state => state.user,
      weatherRegions: state => state.weatherRegions
    })
  },
  mounted: function () {
    // this.$store.dispatch('getUserInfo')
    // this.$store.dispatch('getWeatherRegions')
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
</style>



// WEBPACK FOOTER //
// src/views/Profile.vue